// removed by extract-text-webpack-plugin
module.exports = {"cell":"styles__cell___32LRY","timestamp":"styles__timestamp___28d7h","text":"styles__text___2UReZ","panelists":"styles__panelists___tMfGd","media":"styles__media___2T7X9","comment":"styles__comment___1E63z","likes":"styles__likes___UwORw","tags":"styles__tags___ErELE","sentiments":"styles__sentiments___3b5Sw","actions":"styles__actions___XkXEn"};


//////////////////
// WEBPACK FOOTER
// ./components/qual/Table/TableHeader/TableHeaderCell/styles.scss
// module id = GSXd
// module chunks = 0